import { TIPTAP_ACTION_BUTTON_TYPE, TIPTAP_LINK_BUTTON_TYPE } from 'ricos-content';
import { Decoration_Type, Node_Type } from 'ricos-schema';

export const RicosPluginToolbarNames = {
  ACTION_BUTTON: TIPTAP_ACTION_BUTTON_TYPE,
  LINK_BUTTON: TIPTAP_LINK_BUTTON_TYPE,
  LINK: Decoration_Type.LINK,
  ANCHOR: Decoration_Type.ANCHOR,
  VIDEO: Node_Type.VIDEO,
  DIVIDER: Node_Type.DIVIDER,
  FILE: Node_Type.FILE,
  GALLERY: Node_Type.GALLERY,
  GIF: Node_Type.GIF,
  HTML: Node_Type.HTML,
  IMAGE: Node_Type.IMAGE,
  LINK_PREVIEW: Node_Type.LINK_PREVIEW,
  POLL: Node_Type.POLL,
  EMBED: Node_Type.EMBED,
  APP_EMBED: Node_Type.APP_EMBED,
  COLLAPSIBLE_LIST: Node_Type.COLLAPSIBLE_LIST,
  COLLAPSIBLE_ITEM: Node_Type.COLLAPSIBLE_ITEM,
  COLLAPSIBLE_ITEM_TITLE: Node_Type.COLLAPSIBLE_ITEM_TITLE,
  COLLAPSIBLE_ITEM_BODY: Node_Type.COLLAPSIBLE_ITEM_BODY,
  TABLE: Node_Type.TABLE,
  TABLE_CELL: Node_Type.TABLE_CELL,
  TABLE_ROW: Node_Type.TABLE_ROW,
  AUDIO: Node_Type.AUDIO,
} as const;

export type RicosPluginToolbarNamesValues =
  (typeof RicosPluginToolbarNames)[keyof typeof RicosPluginToolbarNames];
